import type { TRuleEditorCommonProps } from '../types';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import type { TSelectBase } from 'types/general.types';
import type { TQuestionRuleCondition } from 'types/rules.types';

interface Props extends TRuleEditorCommonProps {
  condition: TQuestionRuleCondition;
  items: TSelectBase[];
  onChange: (patch: Partial<TQuestionRuleCondition>) => void;
}

const MULTI_VALUE_OPERATORS = ['IS_IN', 'IS_NOT_IN', 'INCLUDES'];

const RuleConditionIfAnswerSelects = ({ condition, isReadOnly, items, onChange }: Props) => {
  const isMulti = MULTI_VALUE_OPERATORS.includes(condition.operator ?? '');
  const value: string[] = Array.isArray(condition.value)
    ? condition.value.map(String)
    : condition.value !== undefined
      ? [String(condition.value)]
      : [];

  return (
    <HubertCombobox
      itemName="answer"
      isMulti={isMulti}
      items={items}
      disabled={isReadOnly}
      value={isMulti ? value : (value[0] ?? '')}
      onValueChange={(next) => {
        const nextValue = isMulti ? (Array.isArray(next) ? next : [next]) : next;
        onChange({ value: nextValue as string | string[] });
      }}
    />
  );
};

export default RuleConditionIfAnswerSelects;
